import React from 'react';
import Modal from '../../../components/modals';
import Select, { components } from 'react-select';
import { gql } from '@apollo/client';
import _ from 'lodash';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';
import InputHeader from '../../global/inputwithHeader';
import LoadingBar from '../../global/loadingBar';

import RecordMemCardBackup from './recordMemCardBackup';
import { withRouter } from '../../../../services/withRoute';
import jwt_decode from 'jwt-decode';
var validator = require('validator');

const updateMCStatus = gql`
	mutation UpdateMcStatus(
		$workspaceId: String!
		$qrCode: String!
		$status: McStatus!
		$projectId: ID!
		$eventId: ID!
	) {
		updateMcStatus(
			workspaceId: $workspaceId
			qrCode: $qrCode
			status: $status
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

const updateMemoryCard = gql`
	mutation UpdateMemoryCard(
		$workspaceId: String!
		$qrCode: String!
		$projectId: ID!
		$eventId: ID!
		$updateMemoryCardInput: UpdateMemoryCardInput
	) {
		updateMemoryCard(
			workspaceId: $workspaceId
			qrCode: $qrCode
			projectId: $projectId
			eventId: $eventId
			updateMemoryCardInput: $updateMemoryCardInput
		) {
			message
		}
	}
`;

const releaseMemoryCard = gql`
	mutation ReleaseMemoryCard(
		$workspaceId: String!
		$qrCode: String!
		$projectId: ID!
		$eventId: ID!
	) {
		releaseMemoryCard(
			workspaceId: $workspaceId
			qrCode: $qrCode
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

const verifyEmptyMemoryCard = gql`
	mutation ConfirmEmptyMcBackupVerification(
		$workspaceId: String!
		$qrCode: String!
		$projectId: ID!
		$eventId: ID!
	) {
		confirmEmptyMcBackupVerification(
			workspaceId: $workspaceId
			qrCode: $qrCode
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

const addEmptyMemoryCard = gql`
	mutation AddEmptyMcBackup(
		$workspaceId: String!
		$qrCode: String!
		$projectId: ID!
		$eventId: ID!
	) {
		addEmptyMcBackup(
			workspaceId: $workspaceId
			qrCode: $qrCode
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

class RecordMC extends ProjectsGraphQl {
	constructor(props) {
		super(props);
		this.state = {
			selectedMC: props.selectedMC,
			showMemoryCardRecordUploadModal: false,
			showDiscardModal: false,
			recordType: '',
			backupForModal: null,
			isAPISubmitting: false,
			showReleseWarnModal: false,
			releaseCardByUsers: [
				'6454833e190108d64b960620',
				'626d3751c5c41818a3994c97',
				'6130c100be69f58fab166b1a',
				'6130c2540dd5d2d3c5c1c5f8',
				'61f24231e95290dd8109e835',
				'6371e28d70277631cf5595ee',
				'63692b30a5899b0cf3eeca16',
				'63fb8b151cced2d24dc9553e',
				'65801cc1d193f5d333298dac',
				'64b7d3b82683a17e01bc07be',
				'65801cc1d193f5d333298dac',
				'626a65d0ee16b1c1586e3112',
				'64ce91a5aec5091983e7f906',
				'5fb60454eb727c03765013b4',
				'629871d2444228bfd19ff359',
				'61768e9b3579608596ea84c5',
				'6282633d4fdb755ab362b760',
				'641c0f33763b4a3b079ba857',
				'631096e5c13f9201e2025ca3',
				'64be23b825c27fd7c754ff91',
				'64bfaef74cb5707a2623487b',
			],
		};
	}

	componentWillReceiveProps = (nextProps) => {
		this.setState({
			selectedMC: nextProps.selectedMC,
		});
	};

	componentDidMount = () => {
		let userToken = localStorage.getItem('usertoken');
		var decoded = validator.isJWT(userToken) ? jwt_decode(userToken) : null;

		this.setState({
			userID: decoded.user_id,
		});
	};

	handleSubmitForVerification = async () => {
		this.setState({ isAPISubmitting: true });
		let json = {
			qrCode: this.state.selectedMC.qrCode,
			status: 'verificationPending',
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
		};

		await this.updateMCStatus(updateMCStatus, json);
		this.setState({ isAPISubmitting: false });
	};

	handleVerificationComplete = async () => {
		this.setState({ isAPISubmitting: true });
		let json = {
			qrCode: this.state.selectedMC.qrCode,
			status: 'formatPending',
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
		};

		await this.updateMCStatus(updateMCStatus, json, 'backup verification');
		this.setState({ isAPISubmitting: false });
	};

	updateMemoryCardSize = async (isEmpty) => {
		this.setState({ isAPISubmitting: true });
		let json = {
			qrCode: this.state.selectedMC.qrCode,
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
			updateMemoryCardInput: {
				isEmpty: isEmpty,
			},
		};

		await this.updateMemoryCard(updateMemoryCard, json);
		this.setState({ isAPISubmitting: false });
	};

	handleFormatMC = async () => {
		this.setState({ isAPISubmitting: true });
		let json = {
			qrCode: this.state.selectedMC.qrCode,
			status: 'ready',
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
		};

		await this.updateMCStatus(updateMCStatus, json, 'format');
		this.setState({ isAPISubmitting: false });
	};

	releaseMemoryCard = async () => {
		this.setState({ isAPISubmitting: true });
		let json = {
			qrCode: this.state.selectedMC.qrCode,
			status: 'ready',
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
		};

		await this.updateMCStatus(releaseMemoryCard, json, 'Released');
		this.setState({ isAPISubmitting: false });
	};

	verifyEmptyMemoryCard = async () => {
		this.setState({ isAPISubmitting: true });
		let json = {
			qrCode: this.state.selectedMC.qrCode,
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
		};

		//await this.updateMemoryCard(addEmptyMemoryCard, json, 'format');
		await this.updateMemoryCard(verifyEmptyMemoryCard, json, 'Released');
		this.setState({ isAPISubmitting: false });
	};

	componentDidUpdate(prevProps) {
		if (this.props.selectedMC.backupLogs !== prevProps.selectedMC.backupLogs) {
			this.setState({
				selectedMC: this.props.selectedMC,
			});
		}
	}

	showMemoryCardRecordUploadModal = (recordType = '', backup = null) => {
		this.setState({
			recordType,
			showMemoryCardRecordUploadModal: !this.state.showMemoryCardRecordUploadModal,
			backupForModal: backup,
		});
	};

	handleCloseModal = () => {
		this.setState({ showDiscardModal: true });
	};

	render() {
		return (
			<>
				<Modal
					handleClose={() => this.props.close()}
					show={this.props.show}
					modalType={'right-add'}
				>
					<div className="memory-card-modal-container">
						<div className="mc-header-container">
							<div className="header-left-container">
								<div className="header-title-container">
									<span className="header-title">
										{_.has(this.state.selectedMC, 'qrCode') &&
										this.state.selectedMC.qrCode
											? this.state.selectedMC.qrCode.toUpperCase()
											: ''}
									</span>
								</div>
							</div>
						</div>
						<div className="mc-body-container">
							<div className="mc-body-section-container">
								<div
									className="mc-body-section-header"
									style={{ cursor: 'default' }}
								>
									<span className="section-header-title">
										Is this card empty ?
									</span>

									<div
										className="yes-no-toggle-container"
										onClick={() =>
											_.size(this.state.selectedMC.backupLogs) > 0 ||
											this.state.isAPISubmitting ||
											this.state.selectedMC.status === 'formatPending' ||
											this.state.selectedMC.status === 'ready'
												? ''
												: this.updateMemoryCardSize(
														!this.state.selectedMC.isEmpty,
												  )
										}
									>
										<span
											className={
												'button' +
												(this.state.selectedMC.isEmpty === true
													? ''
													: ' no-active')
											}
										>
											No
										</span>
										<span
											className={
												'button' +
												(this.state.selectedMC.isEmpty === true
													? ' yes-active'
													: '')
											}
										>
											Yes
										</span>
									</div>
								</div>
							</div>

							<div className="mc-body-section-container">
								<div
									className="mc-body-section-header"
									style={{ cursor: 'default' }}
								>
									<span className="section-header-title">
										Backups (
										{this.state.selectedMC.backupLogs
											? _.size(this.state.selectedMC.backupLogs)
											: '0'}
										)
									</span>
									{this.state.selectedMC.status != 'ready' ? (
										<span
											className="record-btn"
											onClick={() =>
												this.showMemoryCardRecordUploadModal('record')
											}
										>
											Record a Backup
										</span>
									) : null}
								</div>
								{_.size(this.state.selectedMC.backupLogs) > 0 ? (
									<table className="mc-table equal-spacing">
										<thead>
											<tr>
												<th>HARD DRIVE</th>
												<th>BACKUP SIZE</th>

												<th>BACKUP BY</th>

												<th>VERIFIED BY</th>
											</tr>
										</thead>
										<tbody>
											{_.map(
												this.state.selectedMC.backupLogs,
												(backup, index) => {
													return (
														<tr
															style={{
																cursor: 'pointer',
															}}
															onClick={() =>
																this.showMemoryCardRecordUploadModal(
																	this.state.userID ===
																		backup.createdBy.id
																		? 'backupPending'
																		: 'verificationPending',
																	backup,
																)
															}
														>
															<td>
																<div
																	className="mc-table-cell"
																	style={{
																		display: 'flex',
																	}}
																>
																	<div
																		style={
																			_.size(
																				_.filter(
																					this.props
																						.hardDrivesList,
																					{
																						qrCode: backup.hddQrCode,
																					},
																				),
																			) > 0 &&
																			_.filter(
																				this.props
																					.hardDrivesList,
																				{
																					qrCode: backup.hddQrCode,
																				},
																			)[0]['category'] ===
																				'working'
																				? {
																						background:
																							'#03a0ff',
																						width: '10px',
																						height: '10px',
																						borderRadius:
																							'25px',
																						margin: '2px 5px',
																				  }
																				: _.size(
																						_.filter(
																							this
																								.props
																								.hardDrivesList,
																							{
																								qrCode: backup.hddQrCode,
																							},
																						),
																				  ) > 0 &&
																				  _.filter(
																						this.props
																							.hardDrivesList,
																						{
																							qrCode: backup.hddQrCode,
																						},
																				  )[0][
																						'category'
																				  ] === 'backup'
																				? {
																						background:
																							'#fe2c2b',
																						width: '10px',
																						height: '10px',
																						borderRadius:
																							'25px',
																						margin: '2px 5px',
																				  }
																				: {
																						background:
																							'#7B7B7B',
																						width: '10px',
																						height: '10px',
																						borderRadius:
																							'25px',
																						margin: '2px 5px',
																				  }
																		}
																	></div>
																	{backup.hddQrCode
																		? backup.hddQrCode.toUpperCase()
																		: ''}
																</div>
															</td>
															<td>
																<div className="mc-table-cell">
																	{this.state.selectedMC
																		.isEmpty === true
																		? backup.backupSize
																			? `${backup.backupSize} GB`
																			: 'Empty'
																		: `${backup.backupSize} GB`}
																</div>
															</td>

															<td>
																<div className="mc-table-cell green-color-text">
																	{backup.createdBy &&
																	backup.createdBy.id
																		? backup.createdBy.name
																		: ''}
																</div>
															</td>
															<td>
																<div
																	className={
																		'mc-table-cell' +
																		(backup.verifiedBy &&
																		backup.verifiedBy.id
																			? ' green-color-text'
																			: ' red-color-text')
																	}
																>
																	{backup.verifiedBy &&
																	backup.verifiedBy.id
																		? backup.verifiedBy.name
																		: 'Not Verified'}
																</div>
															</td>
														</tr>
													);
												},
											)}
										</tbody>
									</table>
								) : null}
							</div>
						</div>
						{/* this is for submit button  */}
						<div className="mc-foother-btn-container color-background">
							<span className="left-cancel-btn" style={{ cursor: 'default' }}></span>
							{this.state.selectedMC.status != 'ready' &&
							_.has(this.state.selectedMC, 'backupLogs') &&
							_.size(this.state.selectedMC.backupLogs) >= 1 &&
							_.size(this.state.selectedMC.backupLogs) ===
								_.size(
									_.filter(this.state.selectedMC.backupLogs, {
										isVerified: true,
									}),
								) ? (
								this.state.isAPISubmitting ? (
									<span className={'add-edit-btn loading-btn'}>
										<LoadingBar />
										{this.state.selectedMC.status === 'backupPending'
											? 'Submit for Verification'
											: this.state.selectedMC.status === 'verificationPending'
											? 'Mark as verification done'
											: this.state.selectedMC.status === 'formatPending'
											? 'Format Done'
											: ''}
									</span>
								) : _.indexOf(this.state.releaseCardByUsers, this.state.userID) >=
								  0 ? (
									<span
										className={'add-edit-btn'}
										onClick={() =>
											this.state.isAPISubmitting
												? ''
												: this.setState({
														showReleseWarnModal: true,
												  })
										}
									>
										Release
									</span>
								) : (
									<span className={'add-edit-btn disabled'}>
										Only for Selected Users
									</span>
								)
							) : (
								''
							)}
						</div>
					</div>
				</Modal>
				{this.state.showMemoryCardRecordUploadModal === true ? (
					<RecordMemCardBackup
						handleClose={(e) => [this.showMemoryCardRecordUploadModal()]}
						show={this.state.showMemoryCardRecordUploadModal}
						close={(e) => this.showMemoryCardRecordUploadModal()}
						qrCode={this.state.selectedMC.qrCode}
						selectedMC={this.state.selectedMC}
						onMCBackedUp={this.props.onMCBackedUp}
						recordType={this.state.recordType}
						backupForModal={this.state.backupForModal}
					/>
				) : null}
				<Modal
					handleClose={() => this.setState({ showDiscardModal: false })}
					show={this.state.showDiscardModal}
					modalType={'center'}
				>
					<div className="center-confirm-delete-new">
						<div className="delete-modal-header">DISCARD CHANGES</div>
						<div className="middle-delete-container">
							<div className="middle-text">Are you sure?</div>
							<div className="middle-desc">
								If you discard this information, you cannot undo this
							</div>
						</div>
						<div className="bottom-delete-btns">
							<span
								className="cancel-btn"
								onClick={(e) => this.setState({ showDiscardModal: false })}
							>
								No, Cancel
							</span>
							<span
								className="delete-btn"
								onClick={(e) => {
									this.props.handleClose();
									this.setState({ showDiscardModal: false });
								}}
							>
								Yes, Discard
							</span>
						</div>
					</div>
				</Modal>
				<Modal
					handleClose={() => this.setState({ showReleseWarnModal: false })}
					show={this.state.showReleseWarnModal}
					modalType={'center'}
				>
					<div className="center-confirm-delete-new">
						<div className="delete-modal-header">RELEASE MEMORY CARD</div>
						<div className="middle-delete-container">
							<div className="middle-text">Are you sure?</div>
							<div className="middle-desc">
								If you release this memory card, you cannot update the status for
								this memory card again.
							</div>
						</div>
						<div className="bottom-delete-btns">
							<span
								className="cancel-btn"
								onClick={(e) =>
									this.setState({
										showReleseWarnModal: false,
									})
								}
							>
								No, Cancel
							</span>
							<span
								className="delete-btn"
								onClick={(e) => {
									this.releaseMemoryCard();
									this.setState({
										showReleseWarnModal: false,
									});
								}}
							>
								Yes, Relase
							</span>
						</div>
					</div>
				</Modal>
			</>
		);
	}
}

export default withRouter(RecordMC);
